export function shouldReplaceGoogleCalendarSource(
  savedCalendarId: string | undefined,
  incomingCalendarId: string | undefined,
  primaryCalendarIds: ReadonlySet<string>
): boolean {
  return (
    savedCalendarId === incomingCalendarId ||
    !primaryCalendarIds.has(savedCalendarId ?? '')
  )
}